import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { experiencesSetTitle, SetTitleParam } from '~/generated';
import { extractData } from '~/utils/query-utils';

type UpdateExperienceTitleParams = {
  experienceId: number;
  body: SetTitleParam;
};

export const useUpdateExperienceTitle = (
  options: UseMutationOptions<
    void,
    unknown,
    UpdateExperienceTitleParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateExperienceTitleParams) =>
      extractData(
        experiencesSetTitle({
          path: { experienceId: data.experienceId },
          body: data.body,
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['Experiences'],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
